export const toTagsParameter = (tagIds: string[]): string =>
  tagIds.map((id) => `tags=${id}`).join('&')
